
export const TEXT_DELETE_TEXT = "Are You Sure You Want To Delete This Record,\n\n Once Deleted,\n\n It Will Be Deleted Forever.";
export const TEXT_DATA_LOADED = "Data Was Loaded Successfully";
export const TEXT_ERROR_INPUTS = "Sorry All Inputs Are Required";
export const TEXT_ERROR_INPUTS_CONTACTS = "Sorry All Inputs Are Required \n\nOR \n\nContact Must  Be of 10 Digits";
export const TEXT_CONNECTION_ERROR = "\n\n Sorry Un Able To Connect To The Host Try Again";
